// removed by extract-text-webpack-plugin
module.exports = {"style":"_1pX-LFCV7whqKptnqOeXLB","dot":"_1ZDWlKwq9XXG7ewC-1T_H8"};


//////////////////
// WEBPACK FOOTER
// ./client/component/qiyucontent/style.less
// module id = ZOqP
// module chunks = 6